import React from "react";

function Hero() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-inner">
          <div className="hero-copy">
            <h1>Invest in everything with confidence</h1>
            <p>
              A premium trading and investment platform built for speed,
              transparency, and control. Discover stocks, mutual funds, F&O, and
              more with one modern experience.
            </p>
            <button className="btn btn-primary">Signup now</button>
          </div>
          <div className="hero-visual">
            <img
              src="/media/images/homeHero.png"
              alt="Zerodha investment platform overview"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
